<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of Suppliers</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showForm()"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New Supplier
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                Search Supplier
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">

          <div class="row">
            <div class="col-md-10">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>
            </div>
            <div class="col-md-2">
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </div>
          </div>
          <hr/>
          
            <div class="co-md-12">
                <div class="section">
                    <b-table id="item-table"
                      :fields="fields"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      :filter="filter"
                      hover
                      :items="itemList" 
                      :per-page="perPage"
                      :current-page="currentPage">
                      <!-- A virtual column -->
                      <template #cell(sno)="data">
                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                      </template>
                      <template #cell(action)="data">
                        <a
                          v-on:click="showForm(data.item.supplier_id)"
                          class="btn label-warning btn-xs"
                          style="float: left;display: block; width: 100%;"
                          ><i class="fa fa-edit"></i> Edit</a
                        >
                      </template>
                    </b-table>
                  <!-- Show pagination links -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      aria-controls="item-table"
                      hide-ellipsis
                      ></b-pagination>
                </div>
            </div>

        </div> 
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-8"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Supplier
          </h4>
        </template>
        <template #body>
          <AddSupplier
            :supplierId="itemId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddSupplier from "../components/AddSupplier.vue";
import PanelModal from "../components/PanelModal.vue";
import { BTable, BPagination, BFormInput, BButton } from 'bootstrap-vue'

export default {
  name: "Supplier",
  components: {
    AddSupplier,
    PanelModal,
    BPagination,
    BTable,
    BFormInput,
    BButton
  },
  data() {
    return {
      showFormModal: false,
      itemId: "",
      itemList: [],
      filter: null,
      filterOn: ['supplier_name', 'supplier_address', 'supplier_phone'],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'supplier_name', label: 'Supplier Name'},
        { key:'supplier_address', label: 'Address'},
        { key:'supplier_phone', label: 'Phone'},
        { key:'action', label: 'Action'},
        ]
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_suppliers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.supplierList;
            this.totalRows = this.itemList.length
          }
        });
    },
    showForm: function(supplierid) {
      console.log(supplierid);
      this.itemId = supplierid;
      this.showFormModal = true;
    },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
  },
  computed: {
    rowCount: function () {
      return this.itemList.length
    }
  },
  mounted(){
    this.getList()
  }
};
</script>
